import { get } from 'lodash'

export const types = {
  FETCH_START: 'FETCH_START',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAILURE: 'FETCH_FAILURE',
  CACHE_SUCCESS: 'CACHE_SUCCESS',
}

const reducer = (state, action) => {
  switch (action.type) {
    case types.FETCH_START:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      }
    case types.FETCH_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        numRecipients: get(action, 'payload.Size', 0),
      }
    case types.FETCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      }
    case types.CACHE_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        numRecipients: get(action, 'payload'),
      }
    default:
      throw new Error(`action type '${action.type}' is not a valid type`)
  }
}

export default reducer
